import React from 'react'

import {
    ResidentListTableContainer, 
} from './../resident.style'

import DeleteResidentBtn from './delete_resident_btn'
import { gql,useQuery } from '@apollo/client';
import { Pagination, Spinner } from 'evergreen-ui'
import Cookies from 'js-cookie';
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style';
import AddAssetsPlaceholder from '../../../../../widget/add_assets_placeholder';



export const FETCH_RESIDENTS = gql`
query Residents_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  residents_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    email
    name
    phone
    photo
    facility
    id
    isAccountActivated
    createdAt
    savedCards {
      _id
      expMonth
      maskedPan
      expYear
      isPrimary
    }
  }
}

`;


function ResidentListTable() {
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_RESIDENTS,{
variables: {
    facilityId:facilityId,
    pagination: {
        "cursor": null,
        "limit": 30
    },
 },
});
  return (
    <div>

    <ResidentListTableContainer>
            {/* {facilityId} */}
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>Name</TableHead>
                    <TableHead>Email</TableHead>
                    <TableHead>Phone No</TableHead>
                    <TableHead>Action</TableHead>
                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.residents_getByFacility.map((user) => 
                        <TableBodyRow
                            
                        >
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{user.crescent}</td>
                            <td>
                                <DeleteResidentBtn/>
                            </td>
                        </TableBodyRow>
                        )
                    }
                </tbody>
            </table>
            <center>
              <AddAssetsPlaceholder/>
            </center>
           
            <Pagination className='transparent z-depth-0' page={1} totalPages={5}></Pagination>
        </ResidentListTableContainer>  
    </div>
  )
}

export default ResidentListTable